import React, { useCallback, useEffect, useState } from "react";
import { Container } from "./style";
import { useApi } from "../../../hooks/api";
import { ModalHeader } from "../../ModalHeader";
import { useGlobal } from "../../../hooks/global";
import { ModalGeneric } from "../../ModalGeneric";
import { ContentOrLoading } from "../../Loadings/ContentOrLoading";
import { ViewContractModelContent } from "./content";

interface IModalViewContractModelProps {
    onCancel: Function;
    contractModelId: string;
    openModal: boolean;
    backgroundVisible?: boolean;
}

const texts: any = {
    title: "Visualizar Modelo de Contrato",
    subTitle: "Modelo de contrato",
};

export const ModalViewContractModel: React.FC<IModalViewContractModelProps> = (props) => {
    const { onCancel, openModal, backgroundVisible, contractModelId } = props;

    const { api } = useApi();
    const { theme, notify } = useGlobal();

    const [loading, setLoading] = useState(true);
    const [contractModelData, setContractModelData] = useState<{ text: string } | null>(null);

    const fetchContractModel = useCallback(async () => {
        if (!contractModelId) {
            setLoading(false);
            return;
        }

        setLoading(true);
        try {
            const { data } = await api.get(`/contract-models/${contractModelId}`);
            setContractModelData({ text: data.text || "" });
        } catch (err) {
            notify("Erro ao buscar o modelo de contrato", "error");
            onCancel();
        } finally {
            setLoading(false);
        }
    }, [contractModelId, api, notify, onCancel]);

    useEffect(() => {
        if (openModal && contractModelId) {
            fetchContractModel();
        }
    }, [openModal, contractModelId, fetchContractModel]);

    return (
        <ModalGeneric
            backgroundVisible={backgroundVisible}
            open={openModal}
            onClose={() => { }}
        >
            <Container theme={theme}>
                <ModalHeader
                    title={texts.title}
                    subTitle={texts.subTitle}
                    onCancel={() => onCancel()}
                    theme={theme}
                />
                <ContentOrLoading type="wave" loading={loading} theme={theme}>
                    {!loading && contractModelData && (
                        <ViewContractModelContent
                            contractModelData={contractModelData}
                            theme={theme}
                        />
                    )}
                </ContentOrLoading>
            </Container>
        </ModalGeneric>
    );
}; 